module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('date-selection', {
    attrs: {
      "hasBorder": true
    },
    on: {
      "confirm-selection": _vm.fetchData
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.info))]), _vm._v(" "), _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "stats-row"
  }, [_c('el-card', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_vm._v("总订单量")]), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.totalOrders))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-footer",
    class: _vm.totalOrdersChange > 0 ? 'positive' : (_vm.totalOrdersChange < 0 ? 'negative' : 'neutral')
  }, [(_vm.totalOrdersChange > 0) ? _c('i', {
    staticClass: "el-icon-upload2 stat-icon"
  }) : (_vm.totalOrdersChange < 0) ? _c('i', {
    staticClass: "el-icon-download stat-icon"
  }) : _c('i', {
    staticClass: "el-icon-video-pause stat-icon"
  }), _vm._v(" "), (_vm.totalOrdersChange !== 0) ? [_vm._v("\n              " + _vm._s(_vm.totalOrdersChange > 0 ? '增加' : '减少') + "\n              " + _vm._s(Math.abs(_vm.totalOrdersChange)) + "%\n            ")] : _c('span', {
    staticClass: "stat-neutral"
  }, [_vm._v("数据持平")]), _vm._v(" "), _c('el-tooltip', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', [_c('p', [_vm._v("当前时间段订单量：" + _vm._s(_vm.totalOrders))]), _vm._v(" "), _c('p', [_vm._v("上个" + _vm._s(_vm.selectedType) + "订单量：" + _vm._s(_vm.previousTotalOrders))]), _vm._v(" "), (_vm.totalOrdersChange !== 0) ? _c('p', [_vm._v("\n                    环比变化：" + _vm._s(_vm.totalOrdersChange > 0 ? '增加' : '减少') + " " + _vm._s(Math.abs(_vm.totalOrdersChange)) + "%\n                  ")]) : _c('p', [_vm._v("环比变化：数据持平")])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('i', {
    staticClass: "el-icon-warning"
  })])], 2)]), _vm._v(" "), _c('el-card', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_vm._v("销量金额")]), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v("¥" + _vm._s(_vm.formatAmount(_vm.salesAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-footer",
    class: _vm.salesAmountChange > 0 ? 'positive' : (_vm.salesAmountChange < 0 ? 'negative' : 'neutral')
  }, [(_vm.salesAmountChange > 0) ? _c('i', {
    staticClass: "el-icon-upload2 stat-icon"
  }) : (_vm.salesAmountChange < 0) ? _c('i', {
    staticClass: "el-icon-download stat-icon"
  }) : _c('i', {
    staticClass: "el-icon-video-pause stat-icon"
  }), _vm._v(" "), (_vm.salesAmountChange !== 0) ? [_vm._v("\n              " + _vm._s(_vm.salesAmountChange > 0 ? '增加' : '减少') + "\n              " + _vm._s(Math.abs(_vm.salesAmountChange)) + "%\n            ")] : _c('span', {
    staticClass: "stat-neutral"
  }, [_vm._v("数据持平")]), _vm._v(" "), _c('el-tooltip', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', [_c('p', [_vm._v("当前时间段销量金额：¥" + _vm._s(_vm.salesAmount))]), _vm._v(" "), _c('p', [_vm._v("上个" + _vm._s(_vm.selectedType) + "销量金额：¥" + _vm._s(_vm.previousSalesAmount))]), _vm._v(" "), (_vm.salesAmountChange !== 0) ? _c('p', [_vm._v("\n                    环比变化：" + _vm._s(_vm.salesAmountChange > 0 ? '增加' : '减少') + " " + _vm._s(Math.abs(_vm.salesAmountChange)) + "%\n                  ")]) : _c('p', [_vm._v("环比变化：数据持平")])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('i', {
    staticClass: "el-icon-warning"
  })])], 2)]), _vm._v(" "), _c('el-card', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_vm._v("新增客户")]), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [_c('span', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.newCustomers))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-footer",
    class: _vm.newCustomersChange > 0 ? 'positive' : (_vm.newCustomersChange < 0 ? 'negative' : 'neutral')
  }, [(_vm.newCustomersChange > 0) ? _c('i', {
    staticClass: "el-icon-upload2 stat-icon"
  }) : (_vm.newCustomersChange < 0) ? _c('i', {
    staticClass: "el-icon-download stat-icon"
  }) : _c('i', {
    staticClass: "el-icon-video-pause stat-icon"
  }), _vm._v(" "), (_vm.newCustomersChange !== 0) ? [_vm._v("\n              " + _vm._s(_vm.newCustomersChange > 0 ? '增加' : '减少') + "\n              " + _vm._s(Math.abs(_vm.newCustomersChange)) + "%\n            ")] : _c('span', {
    staticClass: "stat-neutral"
  }, [_vm._v("数据持平")]), _vm._v(" "), _c('el-tooltip', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', [_c('p', [_vm._v("当前时间段新增客户：" + _vm._s(_vm.newCustomers))]), _vm._v(" "), _c('p', [_vm._v("上个" + _vm._s(_vm.selectedType) + "新增客户：" + _vm._s(_vm.previousNewCustomers))]), _vm._v(" "), (_vm.newCustomersChange !== 0) ? _c('p', [_vm._v("\n                    环比变化：" + _vm._s(_vm.newCustomersChange > 0 ? '增加' : '减少') + " " + _vm._s(Math.abs(_vm.newCustomersChange)) + "%\n                  ")]) : _c('p', [_vm._v("环比变化：数据持平")])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('i', {
    staticClass: "el-icon-warning"
  })])], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "sales_chart"
  }, [_c('sales-chart')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ranking-page"
  }, [_c('div', {
    staticClass: "ranking-header"
  }, [_c('h1', [_vm._v("业 绩 排 行 榜")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info))])]), _vm._v(" "), _c('div', {
    staticClass: "top-three"
  }, [_c('div', {
    staticClass: "rank-card rank-second"
  }, [_c('div', {
    staticClass: "crown second"
  }, [_vm._v("NO.2")]), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.rankings[1] ? _vm.rankings[1].avatar : '',
      "alt": "第二名"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.rankings[1] ? _vm.rankings[1].name : ''))]), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_vm._v("\n            金额 " + _vm._s(_vm.rankings[1] ? _vm.rankings[1].score : '') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "rank-card rank-first"
  }, [_c('div', {
    staticClass: "crown first"
  }, [_vm._v("NO.1")]), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.rankings[0] ? _vm.rankings[0].avatar : '',
      "alt": "第一名"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.rankings[0] ? _vm.rankings[0].name : ''))]), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_vm._v("\n            金额 " + _vm._s(_vm.rankings[0] ? _vm.rankings[0].score : '') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "rank-card rank-third"
  }, [_c('div', {
    staticClass: "crown third"
  }, [_vm._v("NO.3")]), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.rankings[2] ? _vm.rankings[2].avatar : '',
      "alt": "第三名"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.rankings[2] ? _vm.rankings[2].name : ''))]), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_vm._v("\n            金额 " + _vm._s(_vm.rankings[2] ? _vm.rankings[2].score : '') + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rank-container",
    style: ({
      maxHeight: '330px',
      overflowY: 'auto'
    })
  }, _vm._l((_vm.rankings.slice(3)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rank-card rank-row"
    }, [_c('div', {
      staticClass: "rank-number"
    }, [_vm._v("NO." + _vm._s(index + 4))]), _vm._v(" "), _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar,
        "alt": "头像"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "score"
    }, [_vm._v("金额 " + _vm._s(item.score))])])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65ad1a27"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/CustomerRanking.vue
// module id = 1016
// module chunks = 3